import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Card from "./Card";
import "../style/Cards.css";

const Cards = ({ cards, isLoaded }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return !isLoaded ? (
    <div className="loading-spinner"></div>
  ) : (
    <div className="Cards">
      {cards.map((item) => {
        return (
          <Link
            to={`/description-game/${item.id}`}
            key={item.id}
            className="card-link"
          >
            <Card
              key={item.id}
              img={item.image}
              title={item.title}
              category={item.category}
              time={item.timeFrame}
            />
          </Link>
        );
      })}
    </div>
  );
};

export default Cards;
